import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./ExitIntentModal.css";

function ExitIntentModal() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        const hasSeenModal = sessionStorage.getItem("hasSeenExitModal");

        if (!hasSeenModal) {
          setIsOpen(true);
          sessionStorage.setItem("hasSeenExitModal", "true");
        }
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/pipedrive", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email }),
      });

      if (response.ok) {
        setIsSubmitted(true);
        // Ferme la modale après 3 secondes
        setTimeout(() => {
          setIsOpen(false);
        }, 3000);
      } else {
        console.error("Erreur serveur lors de la connexion à Pipedrive.");
      }
    } catch (error) {
      console.error("Erreur réseau :", error);
    }
  };

  return (
    <div className="exit-intent-overlay">
      <div className="exit-intent-box glass-panel">
        <button
          className="exit-close-btn"
          onClick={() => setIsOpen(false)}
          type="button"
        >
          &times;
        </button>

        {!isSubmitted ? (
          <div className="exit-content">
            <h2>{t("exitModal.title")}</h2>
            <p>{t("exitModal.description")}</p>
            <form onSubmit={handleSubmit} className="exit-form">
              <input
                type="email"
                placeholder={t("exitModal.placeholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="exit-input"
              />
              <button type="submit" className="exit-submit-btn">
                {t("exitModal.button")}
              </button>
            </form>
          </div>
        ) : (
          <div className="exit-success">
            <h2>{t("exitModal.successTitle")}</h2>
            <p>{t("exitModal.successMessage")}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ExitIntentModal;
